import { useAuthStore } from '@/stores/auth/useAuthStore'

export const useSessionHash = () => {
  const authStore = useAuthStore()

  const createSessionHash = async () => {
    const data = authStore.accessToken + authStore.refreshToken
    try {
      const response = await sha256(data)
      return response
    } catch (error) {
      console.warn(error)
      return ''
    }
  }

  return {
    createSessionHash
  }
}

export async function sha256(text: string): Promise<string> {
  const encoder = new TextEncoder()
  const data = encoder.encode(text)
  const hashBuffer = await globalThis.crypto.subtle.digest('SHA-256', data)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  return hashArray
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('')
    .toLowerCase()
}
